import { Reveal } from "@/components/site/Reveal";
import { processSteps } from "@/data/content";

export const Process = () => (
  <section id="jak-pracujeme" className="scroll-mt-24 bg-background" data-testid="process-section">
    <div className="mx-auto max-w-7xl px-5 py-20 lg:px-10 lg:py-28">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-accent">Jak pracujeme</p>
        <h2 className="mt-3 max-w-lg text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
          Od první návštěvy po dokončenou práci
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-14 lg:grid-cols-12">
        <ol className="relative flex flex-col gap-0 lg:col-span-7">
          {processSteps.map((step, i) => (
            <Reveal key={step.number} delay={i * 0.06}>
              <li className="relative flex gap-6 border-l border-border pb-10 pl-8 last:pb-0">
                <span className="absolute -left-[5px] top-1 h-2.5 w-2.5 rounded-full bg-accent" />
                <span className="w-10 shrink-0 pt-0.5 text-2xl font-semibold text-sand">
                  {step.number}
                </span>
                <div>
                  <h3 className="text-lg font-semibold text-foreground">{step.title}</h3>
                  <p className="mt-1.5 max-w-md text-sm leading-relaxed text-muted-foreground">
                    {step.text}
                  </p>
                </div>
              </li>
            </Reveal>
          ))}
        </ol>
        <Reveal delay={0.15} className="lg:col-span-5">
          <figure>
            <img
              src="./images/rekonstrukce-podlaha.jpg"
              alt="Nová podlaha při rekonstrukci"
              className="h-80 w-full rounded-md object-cover lg:h-[480px]"
              loading="lazy"
            />
            <figcaption className="mt-2 text-xs text-muted-foreground">
              Průběh realizace · nová podlaha
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </div>
  </section>
);
